export const initialise = ():void => {
    const pagination = document.querySelectorAll<HTMLElement>(".attrax-list-pagination-widget");

    pagination.forEach((element) => {
        moveResultperPageintoPagination(element);
    });
}

const moveResultperPageintoPagination = (widget:HTMLElement):void => {
    const resultPerPage = widget.querySelector<HTMLElement>(".attrax-pagination__resultsperpage");
    const pagination = widget.querySelector<HTMLElement>(".attrax-pagination__pagination");
   
    if(!resultPerPage || !pagination) return;


    pagination.appendChild(resultPerPage);
    widget.classList.add("attrax-list-pagination-widget--moved");
}